import React from 'react'
import ErrorLoading from './ErrorLoading'
import CourseCurriculum, { Loading } from './CourseCurriculum'
import { useMembershipJourney } from '../../../hooks/useMembershipJourney'
import { useRefetch } from '../../../hooks/useRefetch'

export const CourseCurriculumWrapper = () => {
  const { person, loading, error, refetch } = useMembershipJourney()
  const { isFetching, reload } = useRefetch()

  if (loading || isFetching) {
    return <Loading />
  }
  
  if (error || !person) {
    return <ErrorLoading refetch={refetch} reload={reload} />
  }

  return (
    <CourseCurriculum
      {...{
        me: person,
        error,
        refetch,
        loading
      }}
    />
  )
}

export default CourseCurriculumWrapper
